var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button } from "semantic-ui-react";
var ChangeReferralLinkVisibility = /** @class */ (function (_super) {
    __extends(ChangeReferralLinkVisibility, _super);
    function ChangeReferralLinkVisibility(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            _this.props.postRequest("/admin/change-marketing-referral-link-status", {
                referralId: {
                    _type: 'MARKETING',
                    id: _this.props.marketingReferralId
                },
                valid: _this.props.valid
            });
        };
        return _this;
    }
    ChangeReferralLinkVisibility.prototype.render = function () {
        var visibility = this.props.valid ? 'visible' : 'invisible';
        return React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Are you sure you want to change the visibility for referral ",
                this.props.marketingReferralId,
                " to ",
                React.createElement("strong", null, visibility)),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: this.props.valid ? 'eye' : 'eye slash', label: "Make " + visibility, labelPosition: 'left', onClick: this.submit, positive: this.props.valid, negative: !this.props.valid }));
    };
    return ChangeReferralLinkVisibility;
}(React.PureComponent));
export default ChangeReferralLinkVisibility;
//# sourceMappingURL=ChangeReferralLinkVisibility.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ChangeReferralLinkVisibility.js
// module id = 1469
// module chunks = 0